import { TemplateOperation } from './templateOperation.js';
import { InheritanceOperation } from './inheritanceOperation.js';

export class OperationsMetadata {
    appSite: string = '';
    private _appFile: string = '';
    appView: string = '';
    templateName: string = '';
    operations: TemplateOperation[] = [];
    hasInheritance: boolean = false;
    inheritanceOperations: InheritanceOperation[] = [];

    constructor() {}

    get appFile(): string { return this._appFile; }
    set appFile(value: string) { this._appFile = value; }
}
